// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2fy5e","fileBtn":"File_fileBtn__cObQu","closeBtn":"File_closeBtn__2YMtR","fileSelected":"File_fileSelected__3FLUB","disabled":"File_disabled__UGCOf"};